<template>
<oarepo-item :collectionCode="collectionCode" :itemId="itemId.toString()">
</oarepo-item>
</template>

<script>
import { Watch, Component, Vue } from 'vue-property-decorator/lib/vue-property-decorator'
import { OARepoItem } from '@oarepo/invenio-oarepo-ui-vue'

export default @Component({
  props: {
    collectionCode: String,
    itemId: [String, Number]
  },
  components: {
    'blah': OARepoItem
  }
})
class RestorationsContainer extends Vue {
  get locale () {
    return this.$i18n.locale.split('-')[0]
  }

  get currentUserId () {
    if (!this.auth$ || !this.auth$.authInfo || !this.auth$.authInfo.user) {
      return null
    }
    return this.auth$.authInfo.user.id
  }

  @Watch('currentUserId')
  updateResource () {
    this.oarepo$.collectionItemModule.reload()
  }
}
</script>
